import "./../../App.css";

function Header() {
  return (
    <div className="header-bar grey">
      <div className="header-container">
        <a href="./">
          <img
            src={process.env.PUBLIC_URL + "/images/my-icon.png"}
            className="header-icon"
            alt="icon"
          />
          <div className="header-text">Dillon Dick</div>
        </a>
      </div>
    </div>
  );
}

export default Header;
